<template>
  <div id="boothSelect">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'boothSelect'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/booth/select/Select.vue